import { Button, Modal } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./audit-log-dialog.scss";
import { AuditLogDeleteResponse } from "domain/auditLog";

import testIds from "testIds.json";

interface Props {
    response?: AuditLogDeleteResponse;
    onClose: () => void;
}

function AuditLogDeletionDialog(props: Props) {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={!!props.response}
            hideModal={props.onClose}
            title={t("AuditLogs.deletion.title", { count: 2 })}
            testId={testIds.common.dialog.itself}
            className={style.dialog}
            dataType="DELETE_AUDIT_LOGS_IN_PROGRESS"
            buttons={
                <div className={style.centeredButton}>
                    <Button variant="Primary" onClick={props.onClose} testId={testIds.common.dialog.closeButton}>
                        {t("Common.ok")}
                    </Button>
                </div>
            }
        >
            <div>{t("AuditLogs.deletion.inProgress")}</div>
        </Modal>
    );
}

export default AuditLogDeletionDialog;
